import React, { useState, useEffect } from "react";
import { Alert, Badge, Spinner } from "reactstrap";
import InventarioAllocationService from "../services/InventarioAllocationService";

const MaterialStatusIndicator = ({ ordenId, onStatusChange = null }) => {
  const [loading, setLoading] = useState(false);
  const [materialesPendientes, setMaterialesPendientes] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (ordenId) {
      checkMaterialStatus();
    }
  }, [ordenId]);

  const checkMaterialStatus = async () => {
    setLoading(true);
    setError("");
    try {
      const available = await InventarioAllocationService.checkMaterialsAvailable(ordenId);
      setMaterialesPendientes(!available);
      
      if (onStatusChange) {
        onStatusChange(!available);
      }
    } catch (err) {
      console.error("Error checking material status:", err);
      setError("Error al verificar estado de materiales");
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="d-flex align-items-center gap-2">
        <Spinner size="sm" color="primary" />
        <span className="text-muted">Verificando materiales...</span>
      </div>
    );
  }

  if (error) {
    return <Alert color="warning" className="mb-0">{error}</Alert>;
  }

  if (materialesPendientes) {
    return (
      <Alert color="warning" className="mb-0 d-flex align-items-center gap-2">
        <span>⚠️ Material Pendiente</span>
        <Badge color="warning" className="ms-auto">
          No puede iniciar la orden
        </Badge>
      </Alert>
    );
  }

  return (
    <Alert color="success" className="mb-0 d-flex align-items-center gap-2">
      <span>✅ Material Disponible</span>
      <Badge color="success" className="ms-auto">
        Puede iniciar la orden
      </Badge>
    </Alert>
  );
};

export default MaterialStatusIndicator;


